import { select, takeLatest, put } from 'redux-saga/effects'
import { MedicalConsultConstants } from '../store/medicalConsult.constants'
import { IMedicalConsultState } from '../store/medicalConsult.types'
import { getMedicalConsultSelector } from '../selectors'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IStringInput } from '../../../../components/stringInput/StringInput.component'

export function* setPhysicianPicklist() {
  const medicalConsultState: IMedicalConsultState = yield select(getMedicalConsultSelector)
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const { inputRows } = procedureState
  const { physician } = medicalConsultState

  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === MedicalConsultConstants.SET_PHYSICIAN) {
        const setOtherPhysicianInput = row.inputs.find(
          (innerInput) => innerInput.key === MedicalConsultConstants.SET_OTHER_PHYSICIAN
        )
        const props = setOtherPhysicianInput?.props as IStringInput
        if (physician) {
          props.disabled = true
        } else {
          props.disabled = false
        }
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setPhysicianPicklistSaga() {
  yield takeLatest([MedicalConsultConstants.SET_PHYSICIAN], setPhysicianPicklist)
}
